import React, { useMemo } from "react";
import moment from "moment-timezone";

import Header from "../components/fifth_screen/Header";
import Footer from "../components/fifth_screen/Footer";
import PrayerTimesPanel from "../components/fifth_screen/PrayerTimesPanel";

import { getNextPrayerOrJummah } from "../utils/prayerUtils";

const FifthScreen = ({ 
  colorSettings = {}, 
  prayerData, 
  timezone, 
  currentTime 
}) => {
  const {
    headerBackgroundColor = "#000000",
    headerTextColor = "#ffffff",
    headerTimingColor = "#ffffff",

    bodyBackgroundColor = "#222222",
    bodyTextColor = "#ffffff",
    bodyTimingColor = "#39ff14",

    highlightColor = "#CF10FF",

    footerBackgroundColor = "#000000",
    footerTextColor = "#ffffff",
    footerTimingColor = "#39ff14",
  } = colorSettings;

  // ----------------------------------------------------------------
  // ✅ LOGIC FROM THIRD SCREEN (Fixed Arguments)
  // ----------------------------------------------------------------
  const nextEvent = useMemo(() => {
    if (!prayerData || !timezone || !currentTime) return null;
    return getNextPrayerOrJummah(
        currentTime, 
        prayerData.iqamatimes, 
        prayerData.jummahTimes, 
        prayerData.startTimes?.timings, // ✅ Fallback Start Times (Crucial for Fajr logic)
        0
    );
  }, [currentTime, prayerData, timezone]);

  const isJummahMode = useMemo(() => {
    if (!prayerData?.iqamatimes || !currentTime) return false;
    if (nextEvent?.type === 'jummah') return true;

    const isFriday = currentTime.day() === 5;
    if (isFriday) {
       const dateStr = currentTime.format("YYYY-MM-DD");
       const dhuhrStr = prayerData.iqamatimes.dhuhr || prayerData.iqamatimes.zuhr;
       const asrStr = prayerData.iqamatimes.asr;

       if (dhuhrStr && asrStr) {
          const dhuhrTime = moment.tz(`${dateStr} ${dhuhrStr}`, "YYYY-MM-DD h:mm A", timezone);
          const asrTime = moment.tz(`${dateStr} ${asrStr}`, "YYYY-MM-DD h:mm A", timezone);
          if (currentTime.isSameOrAfter(dhuhrTime) && currentTime.isBefore(asrTime)) return true;
       }
    }
    return false;
  }, [currentTime, prayerData, timezone, nextEvent]);

  if (!prayerData || !currentTime) {
    return <div className="bg-black h-screen w-screen flex items-center justify-center text-white">Loading...</div>;
  }

  return (
    <div className="bg-black text-white min-h-screen w-screen flex flex-col font-sans overflow-hidden">
      
      {/* Header */}
      <div
        className="flex justify-between items-center h-[12vh] min-h-[80px] shrink-0"
        style={{
          backgroundColor: headerBackgroundColor,
          color: headerTextColor,
        }}
      >
        <Header 
            timingColor={headerTimingColor} 
            textColor={headerTextColor} 
            currentTime={currentTime}
            prayerData={prayerData}
        />
      </div>

      {/* Main Prayer Timing Panel */}
      <div
        className="flex-1 overflow-y-auto px-2 sm:px-1 flex flex-col items-center justify-center"
        style={{ backgroundColor: bodyBackgroundColor, color: bodyTextColor }}
      >
        <PrayerTimesPanel
          highlightColor={highlightColor}
          labelTextColor={bodyTextColor}
          timingTextColor={bodyTimingColor}
          textColor={bodyTextColor}
          prayerData={prayerData}
          nextEvent={nextEvent}
          isJummahMode={isJummahMode}
        />
      </div>

      {/* Footer */}
      <div
        className="flex justify-evenly items-center h-[12vh] min-h-[80px] shrink-0"
        style={{
          backgroundColor: footerBackgroundColor,
          color: footerTextColor,
        }}
      >
        <Footer 
            timingColor={footerTimingColor} 
            textColor={footerTextColor} 
            prayerData={prayerData}
        />
      </div>
    </div>
  );
};

export default FifthScreen;